import {api_host} from "./fetch.js";

export const pendingEventsGet = (jti) => fetch(api_host + "/admin?action=pendingEventsGet&jti=" + jti)
    .then(res => res.json())

export const eventStatusUpdate = (jti, groupUUID, status) => fetch(api_host + "/admin?action=eventStatusUpdate&jti=" + jti + "&groupUUID=" + groupUUID + "&status=" + status)
    .then(res => res.status === 200)
